import { Download, Key, Refresh } from "iconoir-react";
import { useTranslation } from "react-i18next";
import {
  CloudinaryImage,
  PageHeader,
  UploadMediaModal,
  ViewSubSection,
} from "shared/components";
import { Flex } from "styled-system/jsx";
import { OrganizationBackOfficeTags } from "./OrganizationBackOfficeTags";
import { OrganizationByIdQuery } from "gql/generated";
import { scale } from "@cloudinary/url-gen/actions/resize";
import { css } from "styled-system/css";
import { Button, Icon, LinkButton } from "@ttc3k/trekker";
import { useBackOffice } from "./useBackOffice";
import { isLandscape } from "shared/utils";

type BackOfficeProps = {
  organization: OrganizationByIdQuery["organizationById"];
};

export const BackOffice = ({ organization }: BackOfficeProps) => {
  const { t } = useTranslation("directory", {
    keyPrefix: "ORGANIZATION.BACK_OFFICE",
  });

  const {
    isTagModalOpen,
    isUploadLogoModalOpen,
    setIsTagModalOpen,
    setIsUploadLogoModalOpen,
    onUploadComplete,
  } = useBackOffice(organization);

  return (
    <>
      <Flex flexDir={"column"} gap={"500"}>
        <PageHeader
          title={t("TAB_TITLE")}
          description={t("DESCRIPTION")}
          Icon={Key}
        />
        <ViewSubSection
          title={t("LOGO.TITLE")}
          description={t("LOGO.DESCRIPTION")}
        >
          {organization?.logo ? (
            <Flex flexDir={"column"} alignItems={"flex-start"} gap={"150"}>
              <CloudinaryImage
                image={organization.logo}
                imageStyleProps={{
                  objectFit: "scale-down",
                  className: css({ h: "185px", w: "185px" }),
                }}
                resize={
                  isLandscape(organization.logo)
                    ? scale().width(185)
                    : scale().height(185)
                }
              />
              <LinkButton onClick={() => setIsUploadLogoModalOpen(true)}>
                <Icon Element={Refresh} />
                &nbsp;{t("LOGO.REPLACE")}
              </LinkButton>
            </Flex>
          ) : (
            <Button
              mode={"light"}
              size={"lg"}
              w={"max"}
              Icon={Download}
              onClick={() => setIsUploadLogoModalOpen(true)}
            >
              {t("LOGO.UPLOAD")}
            </Button>
          )}
        </ViewSubSection>
        {/* <ViewSubSection title={t("CONTACTS.TITLE")}>
        {t("CONTACTS.TITLE")}
      </ViewSubSection> */}
        <ViewSubSection
          title={t("TAGS.TITLE")}
          description={t("TAGS.DESCRIPTION")}
          buttonLabel={`+ ${t("TAGS.ADD_NEW_TAG")}`}
          onButtonClick={() => setIsTagModalOpen(true)}
        >
          <OrganizationBackOfficeTags
            isTagModalOpen={isTagModalOpen}
            setIsTagModalOpen={setIsTagModalOpen}
            tagVisual={"accent.magenta"}
          />
        </ViewSubSection>
        {/* <ViewSubSection title={t("REGION.TITLE")}>
          {t("REGION.TITLE")}
        </ViewSubSection> */}
      </Flex>

      <UploadMediaModal
        isOpen={isUploadLogoModalOpen}
        isPublicWidget={false}
        onClose={() => setIsUploadLogoModalOpen(false)}
        onUploadComplete={onUploadComplete}
        maxFiles={1}
      />
    </>
  );
};
